// Display text only. Ledger states, filter keys and hotel-defined names stay unchanged.
export const reservationAccountMessages = {
  Account: "Cuenta",
  "Reservation Account": "Cuenta de la reserva",
  "Group Account": "Cuenta del grupo",
  "Account view": "Vista de la cuenta",
  "Back to Reservation Group": "Volver al grupo de reservas",
  "Group {id}": "Grupo {id}",
  "Reservation {id}": "Reserva {id}",
  "Room {number}": "Habitación {number}",
  "Locator: {locator}": "Localizador: {locator}",
  "Main guest: {name}": "Huésped principal: {name}",
  "Room: {number}": "Habitación: {number}",
  "Category: {name}": "Categoría: {name}",
  "Unallocated payment": "Pago sin asignar",
  "Group-level line": "Movimiento del grupo",
  "Loading account...": "Cargando cuenta...",
  "Failed to load account.": "No se pudo cargar la cuenta.",
  "Internal server error generating account": "Se produjo un error del servidor al generar la cuenta.",
  "Reservation group not found": "No se encontró el grupo de reservas.",
  "reservation_group_id is required": "Se necesita un grupo de reservas válido.",
  "No account data available.": "No hay datos de la cuenta disponibles.",
  "Posted revenue": "Ingresos contabilizados",
  "Scheduled revenue": "Ingresos previstos",
  "Unposted past": "Cargos pasados sin contabilizar",
  "Quarantined revenue": "Ingresos en revisión",
  Payments: "Pagos",
  "Balance today": "Saldo actual",
  "Projected balance": "Saldo previsto",
  "Credit/refundable": "Saldo a favor / reembolsable",
  "Showing group-level, reservation and unallocated lines.": "Se muestran los movimientos del grupo, de las reservas y sin asignar.",
  "View reservation": "Ver reserva",
  "Select reservation": "Seleccionar reserva",
  "Clear table filters": "Limpiar filtros de la tabla",
  Date: "Fecha",
  "Res.": "Res.",
  "Room charges": "Cargos de habitación",
  Extras: "Extras",
  Charges: "Cargos",
  State: "Estado",
  Amount: "Importe",
  Unscheduled: "Sin fecha",
  Posted: "Contabilizado",
  Scheduled: "Programado",
  Unposted: "Sin contabilizar",
  Quarantined: "En revisión",
  Cancelled: "Cancelado",
  Pending: "Pendiente",
  Settled: "Liquidado",
  Refunded: "Reembolsado",
  Failed: "Fallido",
  Voided: "Anulado",
  "Room night": "Noche de habitación",
  Charge: "Cargo",
  Payment: "Pago",
  Refund: "Reembolso",
  Clear: "Limpiar",
  Done: "Listo",
  "No values": "Sin valores",
  "From date": "Desde la fecha",
  "To date": "Hasta la fecha",
  "Concept match": "Coincidencia del concepto",
  Contains: "Contiene",
  Exact: "Coincidencia exacta",
  Concept: "Concepto",
  "Amount condition": "Condición del importe",
  "No amount filter": "Sin filtro de importe",
  Equals: "Igual a",
  "Greater than": "Mayor que",
  "Greater or equal": "Mayor o igual que",
  "Less than": "Menor que",
  "Less or equal": "Menor o igual que",
  Between: "Entre",
  To: "Hasta",
  "No lines match the current filters.": "No hay movimientos que coincidan con los filtros actuales.",
};

export function getAccountLineDescription(line, t) {
  const description = String(line.description || "");
  // Only the system-generated prefix is translated; the rate/category suffix is hotel content.
  if (line.column === "room" && /^Room night(?: · |$)/.test(description)) {
    return description.replace(/^Room night/, t("Room night"));
  }
  // These are API fallback labels, not arbitrary words inside names or payment notes.
  if (description === line.source_label && ["Charge", "Payment", "Refund", "Posted revenue"].includes(description)) {
    return t(description);
  }
  return description;
}
